import * as React from "react";
import { Modal, Typography, Card, Box, Button, Grid, Icon, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";
import { selectAcknowledgementsState } from '../sagas/acknowledgementsSlice';
import CancelIcon from "../../../icons/cancelIcon.svg";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  titleText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "18px !important",
    lineHeight: "22px !important",
    color: "#14142B !important",
    textAlign: "center",
  },
  detailsText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "400 !important",
    fontSize: "18px !important",
    lineHeight: "21px !important",
    color: "#000000 !important",
  },
  buttonContainer: {
    position: "absolute",
    bottom: "20px",
    width: 'calc( 100% - 32px )',
    display: 'flex',
    justifyContent: 'center',
  },
});

interface PciAnnouncementModalProps {
  open: boolean;
  handleReview: () => void;
  handleProceed: () => void;
  handleClose?: () => void;
}

export default function PciAnnouncementModal(props: PciAnnouncementModalProps) {
  const classes = useStyles();

  const { isExportingAckForm } = useSelector(selectAcknowledgementsState);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    minHeight: '615px',
    pointerEvents: "auto",
    width: '98%',
    maxWidth: '759px',
    borderRadius: '24px',
    outline: 'none',
  };

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        onClose={() => props.handleClose && props.handleClose()}
      >
        <Card sx={style}>
          {props.handleClose ? (
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <Typography className={classes.titleText} sx={{ mt: 1 }}>
                  Annual PCI Compliance Self-Attestation
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <IconButton sx={{ ml: "30px" }} onClick={() => props.handleClose && props.handleClose()}>
                  <Icon>
                    <img src={CancelIcon} alt="" width={24} height={24} />
                  </Icon>
                </IconButton>
              </Grid>
            </Grid>
          ) : (
            <Typography className={classes.titleText} sx={{ textAlign: 'center', my: 1 }}>
              Annual PCI Compliance Self-Attestation
            </Typography>
          )}

          <Box sx={{ mt: 4, mx: 2 }}>
            <Typography className={classes.detailsText}>
              All merchants that process and receive card payments must maintain compliance with PCI standards.
            </Typography>

            <Typography className={classes.detailsText} sx={{ mt: 2 }}>
              Inosio makes it easy!
            </Typography>

            <Typography className={classes.detailsText} sx={{ mt: 4, mx: 2 }}>
              1. Never write down a card number on a piece of paper. Always type it directly into the card data form in Inosio. Inosio will encrypt and store it securely for you.
            </Typography>

            <Typography className={classes.detailsText} sx={{ m: 2 }}>
              2. Inosio is PCI certified and will prevent you from having to worry about other data handling concerns, however you will need to complete a self-attestation each year for us to keep on file.
            </Typography>

            <Typography className={classes.detailsText} sx={{ m: 2 }}>
              3. Inosio has pre-completed and pre-filled the required PCI documents for you to review and sign. 
            </Typography>

            <Typography className={classes.detailsText} sx={{ mt: 4 }}>
              This document can be intimidating, but since Inosio is your payment processor and we don’t allow you to break the rules you don’t have anything to worry about.
            </Typography>
          </Box>

          <div className={classes.buttonContainer}>
            <Button
              variant="contained"
              style={{
                fontFamily: "'Open Sans', sans-serif",
                fontStyle: "normal",
                fontWeight: 700,
                background: "#ffffff",
                border: "3px solid #39A2DA",
                borderRadius: "24px",
                textTransform: "capitalize",
                color: '#39A2DA',
                width: 132.5,
              }}
              onClick={() => props.handleReview()}
            >
              {isExportingAckForm ? <CircularProgress size={16} /> : 'Review Form'}
            </Button>
            <Button
              variant="contained"
              style={{
                fontFamily: "'Open Sans', sans-serif",
                fontStyle: "normal",
                fontWeight: 700,
                marginLeft: "58px",
                background: "#39A2DB",
                border: "3px solid #39A2DA",
                borderRadius: "24px",
                textTransform: "capitalize",
              }}
              onClick={() => props.handleProceed()}
            >
              Proceed to Signature
            </Button>
          </div>
        </Card>
      </Modal>
    </div>
  );
}
